import Select from "react-select";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import { currency_converter_inr } from "../../../../utils/currencyUtils";
import toastr from "../../../../utils/toast";

function Item({ onClose, data }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm();

  const { setGlobalLoading, token } = useOutletContext();
  const [currency_options, setCurrencyOptions] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const CURRENCY_API_KEY = process.env.REACT_APP_CURRENCY_API_KEY;
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [selectedFinalRetainer, setSelectedFinalRetainer] = useState(null);
  const [SelectedSecondApproval, setSelectedSecondApproval] = useState(null);
  const [SelectedEntity, setSelectedEntity] = useState(null);
  const [ConvertedAmount, setConvertedAmount] = useState(0);
  const [entities, setEntities] = useState([]);

  const expense_options = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];

  const final_retainer_option = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];

  const seconndApprovalOptions = [
    { value: "Approved", label: "Approved" },
    { value: "Not Approved", label: "Not Approved" },
    { value: "On Hold", label: "On Hold" },
  ];

  const selectedExpense = watch("has_expense");
  const FinalRetainer = watch("final_retainer");
  const secondApproval = watch("action");
  const Entity = watch("entity_id");

  const handleCurrencyChange = (e) => {
    const selectedCurrencyId = parseInt(e);
    if (selectedCurrencyId) {
      const currency = data?.currency?.find(
        (c) => c.id === selectedCurrencyId,
      )?.name;
      getConversation(currency);
    }
  };
  const getConversation = async (name) => {
    try {
      setGlobalLoading(true);
      const response = await axios.get(
        `https://api.currconv.com/api/v7/convert?q=${name}_INR&compact=ultra&apiKey=${CURRENCY_API_KEY}`,
      );
      const rate = response.data;
      const value = Object.entries(rate)[0];
      setValue("conversion_rate", value.toFixed(2) || 1);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const onSubmit = async (fromdata) => {
    console.log(fromdata);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/approval2/item_update/`,
        fromdata,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log(response);
      if (response?.status === 200) {
        toastr.success(response?.data?.message);
        onClose();
      } else {
        toastr.error(response?.message);
        onClose();
      }
    } catch (error) {
      console.log(error);
      toastr.error(error);
    } finally {
    }
  };

  useEffect(() => {
    if (!data) {
      return;
    }

    const invoice_data = data?.invoice?.[0];
    const invoice_has_item = data?.invoice_has_items?.[0];
    const role = data?.role?.[0];
    const contract = data?.contract?.[0];

    setValue("id", invoice_has_item?.id);
    setValue("invoice_id", invoice_data?.id);
    setValue("name", invoice_has_item?.name);
    setValue("description", invoice_has_item?.description);
    setValue("raised_date", invoice_has_item?.raised_date);
    setValue("reporting_date", invoice_has_item?.reporting_date);
    setValue("has_expense", Number(invoice_has_item?.has_expense));
    if (Number(invoice_has_item?.has_expense) === 1) {
      setValue("expense_amount", invoice_has_item?.expense_amount);
    }
    setValue("retainer_amount", invoice_has_item?.retainer_amount);
    setValue("amount", invoice_has_item?.amount);
    setValue("currency_id", invoice_data?.currency_id);
    setValue("final_retainer_option", invoice_has_item?.final_retainer);
    setCurrencyOptions(
      data?.currency?.map((c) => ({
        value: c.id,
        label: c.symbol + " " + c.name,
      })),
    );
    setValue("conversion_rate", invoice_has_item?.conversion_rate);
    const final_retainer = Number(invoice_has_item?.final_retainer);
    setValue("final_retainer", final_retainer);
    const option = final_retainer_option.find(
      (opt) => opt.value === final_retainer,
    );
    setSelectedFinalRetainer(option);

    if (Number(invoice_has_item?.final_retainer) === 1) {
      setValue("candidate_name", data?.candidate_name);
      setValue("candidate_id", data?.candidate_id);
    }

    const secondApproval = invoice_has_item?.action ?? "Approved";
    setValue("action", secondApproval);

    const entityOptions = data?.entity?.map((c) => ({
      value: c.id,
      label: c.name,
    }));

    setEntities(entityOptions);

    const entity = invoice_has_item?.entity_id ?? 0;

    setValue("entity_id", entity);
    setSelectedEntity(entityOptions.find((opt) => opt.value === entity));
    setValue("comments", invoice_has_item?.comments);
    let agn = null;
    if (invoice_data?.role_id && role?.contract_id) {
      agn = `AGN : ${contract?.agn}`;
    }
    setValue(
      "second_approval_comments",
      invoice_has_item?.second_approval_comments ?? agn,
    );
  }, [data]);

  const conversion_rate = watch("conversion_rate");
  const expense_amount = watch("expense_amount");
  const retainer_amount = watch("retainer_amount");

  useEffect(() => {
    if (conversion_rate || expense_amount || retainer_amount) {
      console.log(conversion_rate, expense_amount, retainer_amount);
      const total_amount =
        Number(expense_amount ?? 0) + Number(retainer_amount ?? 0);
      const converted_amount = total_amount * Number(conversion_rate ?? 1);
      setValue("amount", total_amount);
      setConvertedAmount(converted_amount.toFixed(0));
    }
  }, [conversion_rate, expense_amount, retainer_amount]);

  useEffect(() => {
    if (selectedExpense !== 1) {
      setValue("expense_amount", 0);
    } else {
      setValue("expense_amount", data?.invoice_has_items?.[0]?.expense_amount);
    }
  }, [selectedExpense]);

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div
          className="modal-dialog modal-dialog-centered modal-md"
          role="document"
        >
          <div className="modal-content">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="modal-header">
                <h4 className="modal-title">Edit Invoice</h4>

                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  onClick={() => {
                    onClose?.();
                  }}
                >
                  <i className="ti ti-x"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Name <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.name ? "is-invalid" : ""}`}
                        {...register("name", {
                          required: true,
                        })}
                        placeholder="Retainer Name"
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Description</label>
                      <textarea
                        type="text"
                        className={`form-control`}
                        {...register("description")}
                        placeholder="Retainer Description"
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Raised Date
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="date"
                        className={`form-control ${errors.raised_date ? "is-invalid" : ""}`}
                        {...register("raised_date", {
                          required: true,
                        })}
                        format="yyyy-MM-dd"
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Reporting Date{" "}
                        <i
                          title="Internal Report"
                          className="fa-solid fa-info-circle text-info"
                        ></i>
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="date"
                        className={`form-control ${errors.reporting_date ? "is-invalid" : ""}`}
                        {...register("reporting_date", {
                          required: true,
                        })}
                        format="yyyy-MM-dd"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Currency Type{" "}
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        options={currency_options}
                        placeholder="Select"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        value={
                          selectedCurrency ??
                          currency_options.find(
                            (opt) =>
                              opt.value === data?.invoice?.[0]?.currency_id,
                          )
                        }
                        onChange={(selected) => {
                          console.log(selected);
                          setSelectedCurrency(selected);
                          setValue("currency_id", selected.value);
                          handleCurrencyChange(selected.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Expenses</label>
                      <Select
                        options={expense_options}
                        placeholder="Select"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        value={expense_options.find(
                          (opt) => opt.value === Number(selectedExpense),
                        )}
                        onChange={(selected) => {
                          setValue("has_expense", selected.value);
                          console.log(selected);
                        }}
                      />
                    </div>
                  </div>
                  {selectedExpense === 1 && (
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label">
                          Expense Amount{" "}
                          <span className="text-danger ms-1">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.expense_amount ? "is-invalid" : ""}`}
                          {...register("expense_amount", {
                            required: true,
                            valueAsNumber: true,
                          })}
                          placeholder="expense_amount"
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  )}
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">
                        retainer_amount{" "}
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.retainer_amount ? "is-invalid" : ""}`}
                        {...register("retainer_amount", {
                          required: true,
                          valueAsNumber: true,
                        })}
                        placeholder="retainer_amount"
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">
                        Amount <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.amount ? "is-invalid" : ""}`}
                        {...register("amount", {
                          required: true,
                          valueAsNumber: true,
                        })}
                        placeholder="amount"
                        autoComplete="off"
                        readOnly={true}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Conversion Rate</label>
                      <input
                        type="text"
                        className={`form-control ${errors.conversion_rate ? "is-invalid" : ""}`}
                        {...register("conversion_rate", {
                          required: true,
                          valueAsNumber: true,
                        })}
                        placeholder="conversion rate"
                        autoComplete="off"
                        readOnly={true}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="mb-3 mt-2">
                      <label className="form-label"></label>
                      <span className="fw-700 text-danger fs-12">
                        {currency_converter_inr(ConvertedAmount)}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label className="form-label">Final Retainer</label>
                      <Select
                        options={final_retainer_option}
                        placeholder="Select"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        value={
                          selectedFinalRetainer ??
                          final_retainer_option.find(
                            (opt) => opt.value === Number(FinalRetainer),
                          )
                        }
                        onChange={(selected) => {
                          setValue("final_retainer", selected.value);
                          setSelectedFinalRetainer(selected);
                        }}
                      />
                    </div>
                  </div>
                  {FinalRetainer === 1 && (
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label">
                          Candidate Name{" "}
                          <span className="text-danger ms-1">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.candidate_name ? "is-invalid" : ""}`}
                          {...register("candidate_name", {
                            required: true,
                          })}
                          placeholder="candidate_name"
                          autoComplete="off"
                          readOnly={true}
                          disabled={true}
                        />
                      </div>
                    </div>
                  )}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        2nd Approval <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        options={seconndApprovalOptions}
                        placeholder="Select"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        value={
                          SelectedSecondApproval ??
                          seconndApprovalOptions.find(
                            (opt) => opt.value === secondApproval,
                          )
                        }
                        onChange={(selected) => {
                          setValue("action", selected.value);
                          setSelectedSecondApproval(selected);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Entity <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        options={entities}
                        placeholder="Select"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        value={
                          SelectedEntity ??
                          entities.find((opt) => opt.value === Entity)
                        }
                        onChange={(selected) => {
                          setValue("entity_id", selected.value);
                          setSelectedEntity(selected);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Comments</label>
                      <input
                        type="text"
                        className={`form-control ${errors.comments ? "is-invalid" : ""}`}
                        {...register("comments")}
                        placeholder="comments"
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Second Approval Comments
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.second_approval_comments ? "is-invalid" : ""}`}
                        {...register("second_approval_comments", {
                          required: true,
                        })}
                        placeholder="second_approval_comments"
                        autoComplete="off"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="modal-footer"
                style={{ justifyContent: "center" }}
              >
                <button type="submit" className="btn btn-primary me-2">
                  Save
                </button>

                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    onClose?.();
                  }}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Item;
